/* GENERATED by packages/tokens/scripts/generate.ts from DESIGN.md — DO NOT EDIT.
   Regenerate: pnpm --filter @echo/tokens gen (dtcg + front matter) */

/** Design tokens as plain values. Prefer className utilities from theme.css; use this where a value is required. */
export const theme = {
  "name": "Stronger Memory",
  "colors": {
    "brand-teal": "#00857d",
    "brand-orange": "#ff7a3d",
    "brand-white": "#ffffff",
    "teal-10": "#e6f3f2",
    "teal-20": "#cce7e5",
    "teal-40": "#66b6b1",
    "teal-60": "#00857d",
    "teal-70": "#006e68",
    "teal-80": "#005854",
    "teal-90": "#0f2f2c",
    "teal-100": "#002725",
    "orange-10": "#fff1e9",
    "orange-20": "#ffe2d3",
    "orange-40": "#ffa77d",
    "orange-60": "#ff7a3d",
    "orange-70": "#e5672c",
    "orange-80": "#d65b22",
    "neutral-0": "#ffffff",
    "neutral-10": "#fafaf8",
    "neutral-20": "#eeeeea",
    "neutral-30": "#d6d6d1",
    "neutral-40": "#b2b2b2",
    "neutral-50": "#999999",
    "neutral-60": "#7f7f7f",
    "neutral-70": "#666666",
    "neutral-80": "#4a4a4a",
    "neutral-90": "#333333",
    "neutral-100": "#1a1a1a",
    "onearly-10": "#f2f2f2",
    "onearly-60": "#6356e5",
    "onearly-70": "#5348bf",
    "blue-10": "#e7f2fc",
    "blue-20": "#cfe5f8",
    "blue-60": "#4098e0",
    "blue-70": "#005faa",
    "info-60": "#2642b3",
    "green-10": "#eef1e8",
    "green-20": "#dfe5d5",
    "green-30": "#c2ccb2",
    "green-40": "#a4b38e",
    "green-60": "#7e9064",
    "green-70": "#5c6b47",
    "red-10": "#fbeaec",
    "red-60": "#dc2626",
    "red-70": "#b2282e",
    "amber-60": "#d97706",
    "yellow-10": "#fff4dc",
    "yellow-20": "#ffe9b8",
    "success-10": "#eaf5ed",
    "success-70": "#2e7d46",
    "primary": "#00857d",
    "secondary": "#ff7a3d",
    "neutral": "#fafaf8",
    "surface": "#ffffff",
    "surface-secondary": "#fafaf8",
    "surface-tertiary": "#eeeeea",
    "surface-highlight-weak": "#e6f3f2",
    "surface-highlight-medium": "#cce7e5",
    "surface-inverse": "#0f2f2c",
    "on-surface": "#1a1a1a",
    "on-surface-medium": "#4a4a4a",
    "on-surface-weak": "#7f7f7f",
    "on-surface-highlight": "#00857d",
    "on-surface-inverse": "#ffffff",
    "border-weak": "#eeeeea",
    "border-default": "#d6d6d1",
    "border-strong": "#7f7f7f",
    "border-highlight": "#00857d",
    "icon-strong": "#1a1a1a",
    "icon-medium": "#666666",
    "icon-on-contrast": "#ffffff",
    "action-primary": "#00857d",
    "action-primary-focus": "#006e68",
    "action-primary-active": "#005854",
    "action-primary-disabled": "#999999",
    "on-action-primary": "#ffffff",
    "action-secondary": "#ffffff",
    "action-secondary-focus": "#e6f3f2",
    "action-secondary-active": "#cce7e5",
    "on-action-secondary": "#00857d",
    "on-action-secondary-focus": "#006e68",
    "action-destructive": "#b2282e",
    "control-unselected": "#ffffff",
    "control-selected": "#cce7e5",
    "on-control-selected": "#005854",
    "attention": "#ff7a3d",
    "on-attention": "#ffffff",
    "status-info": "#2642b3",
    "status-success": "#00857d",
    "status-warning": "#d97706",
    "status-error": "#dc2626",
    "status-error-tint": "#fbeaec",
    "status-warning-tint": "#fff4dc",
    "status-warning-badge": "#ffe9b8",
    "status-neutral-tint": "#eeeeea",
    "status-neutral-badge": "#d6d6d1",
    "status-success-tint": "#eaf5ed",
    "status-success-badge": "#2e7d46",
    "status-neutral-text": "#4a4a4a",
    "exercise-prompt": "#5c6b47",
    "action-onearly": "#6356e5",
    "on-action-onearly": "#ffffff",
    "link-onearly": "#5348bf",
    "link": "#006e68",
    "action-social": "#f2f2f2",
    "exercise-reading": "#4098e0",
    "exercise-writing": "#ff7a3d",
    "exercise-math": "#7e9064",
    "stat-tile": "#e7f2fc",
    "progress-track": "#eeeeea",
    "progress-fill": "#ff7a3d",
    "progress-card": "#ffefe7",
    "progress-card-border": "#ffa77d",
    "badge-done": "#006e68",
    "badge-in-progress": "#ffe9b8",
    "on-badge-in-progress": "#b5730a",
    "on-done-card": "#005854",
    "badge-duration": "#0f6764",
    "welcome-card-group": "#0071ce",
    "leader-card": "#e3f7f5",
    "leader-card-border": "#6ed6d0",
    "overview-card": "#e3f7f5",
    "stat-card-border": "#a8e4df",
    "tag-leader": "#00477f",
    "on-tag": "#ffffff",
    "role-facilitator": "#0071ce",
    "on-role-facilitator": "#ffffff",
    "role-leader": "#cfe5f8",
    "on-role-leader": "#0071ce",
    "role-member": "#fff1e9",
    "on-role-member": "#ff7a3d",
    "tag-info": "#e7f2fc",
    "on-tag-info": "#005faa",
    "segment-selected": "#005854",
    "on-segment-selected": "#ffffff",
    "media-placeholder": "#e3f7f5",
    "group-card": "#dfe5d5",
    "group-card-border": "#a4b38e",
    "progress-fill-group": "#7e9064",
    "progress-fill-highlight": "#4098e0",
    "member-progress-none": "#ff7a3d",
    "member-progress-partial": "#0071ce",
    "member-progress-complete": "#3e9a5c",
    "avatar-green": "#d5eadb",
    "on-avatar-green": "#246439",
    "avatar-yellow": "#ffe9b8",
    "on-avatar-yellow": "#6a4306",
    "avatar-grey": "#eeeeea",
    "on-avatar-grey": "#4a4a4a",
    "avatar-olive": "#dfe5d5",
    "on-avatar-olive": "#37402b",
    "avatar-lavender": "#ccc7ff",
    "on-avatar-lavender": "#6356e5",
    "avatar-orange": "#ff7a3d",
    "on-avatar-orange": "#ffffff",
    "avatar-olive-solid": "#7e9064",
    "on-avatar-olive-solid": "#ffffff",
    "stat-streak": "#0071ce",
    "stat-streak-tint": "#e7f2fc",
    "stat-month": "#00857d",
    "stat-month-tint": "#e6f3f2",
    "stat-best": "#d65b22",
    "stat-best-tint": "#fff1e9",
    "stat-time": "#5c6b47",
    "stat-time-tint": "#eef1e8",
    "achievement-member": "#cfe5f8",
    "achievement-flame": "#ffe2d3",
    "achievement-medal": "#cce7e5",
    "achievement-brain": "#eeeeea",
    "achievement-calendar": "#cfe5f8",
    "achievement-trophy": "#fff4dc",
    "chart-member": "#00857d",
    "chart-you": "#0071ce",
    "chart-grid": "#d6d6d1",
    "chart-bar": "#00afaa",
    "tab-bar": "#cce7e5",
    "tab-bar-glass": "#00857d33",
    "tab-bar-active": "#00857d",
    "on-tab-bar": "#ffffff",
    "on-tab-bar-inactive": "#003e3b",
    "chat-own": "#e7f2fc",
    "chat-own-border": "#cfe5f8",
    "chat-leader": "#cfe5f8",
    "on-chat-leader": "#0071ce",
    "chat-unread": "#b64919",
    "chat-unread-line": "#ffa77d",
    "chat-placeholder": "#999999",
    "group-unread": "#006f69"
  },
  "spacing": {
    "toolbar-control": 44,
    "chat-avatar": 34,
    "chat-profile-avatar": 143,
    "chat-action": 40,
    "chat-composer": 56,
    "chat-banner-art": 80,
    "chat-gutter": 16,
    "chat-page-width": 800,
    "base": 4,
    "internal-sm": 4,
    "internal-md": 8,
    "internal-lg": 12,
    "content-sm": 16,
    "content-md": 20,
    "content-lg": 24,
    "section-sm": 32,
    "section-md": 40,
    "section-lg": 48,
    "gutter": 20,
    "icon-sm": 16,
    "icon-md": 20,
    "icon-lg": 24,
    "icon-xl": 32,
    "task-icon": 44,
    "task-icon-border": 1.5,
    "art-complete-w": 108,
    "tap-target": 48,
    "ruled-line": 48,
    "column-max": 840,
    "hero-max": 504,
    "hero-min": 120,
    "form-max": 480,
    "wide-min": 600,
    "group-chart-height": 191,
    "group-chart-bar": 30,
    "group-member-bar": 108,
    "group-message-art": 80,
    "group-avatar-overlap": 10
  },
  "radius": {
    "xs": 4,
    "sm": 8,
    "md": 12,
    "lg": 16,
    "xl": 20,
    "xxl": 24,
    "full": 9999
  },
  "typography": {
    "display-lg": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 80,
      "fontWeight": "400",
      "lineHeight": 96,
      "letterSpacing": -3
    },
    "display-md": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 48,
      "fontWeight": "500",
      "lineHeight": 58,
      "letterSpacing": -2
    },
    "display-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 40,
      "fontWeight": "400",
      "lineHeight": 47,
      "letterSpacing": -2
    },
    "headline-lg": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 32,
      "fontWeight": "500",
      "lineHeight": 42,
      "letterSpacing": -1
    },
    "stat-value": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 32,
      "fontWeight": "700",
      "lineHeight": 36,
      "letterSpacing": -1
    },
    "headline-md": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 28,
      "fontWeight": "500",
      "lineHeight": 42,
      "letterSpacing": -1
    },
    "headline-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 24,
      "fontWeight": "500",
      "lineHeight": 36,
      "letterSpacing": 0
    },
    "title-lg": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 24,
      "fontWeight": "700",
      "lineHeight": 28,
      "letterSpacing": 0
    },
    "title-md": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 20,
      "fontWeight": "700",
      "lineHeight": 26,
      "letterSpacing": 0
    },
    "title-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 18,
      "fontWeight": "700",
      "lineHeight": 24,
      "letterSpacing": 0
    },
    "body-lg": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 22,
      "fontWeight": "400",
      "lineHeight": 27,
      "letterSpacing": 0
    },
    "passage": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 20,
      "fontWeight": "400",
      "lineHeight": 30,
      "letterSpacing": 0
    },
    "body-md": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 18,
      "fontWeight": "400",
      "lineHeight": 24,
      "letterSpacing": 0
    },
    "body-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 16,
      "fontWeight": "400",
      "lineHeight": 22,
      "letterSpacing": 0
    },
    "body-xs": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 14,
      "fontWeight": "400",
      "lineHeight": 20,
      "letterSpacing": 0
    },
    "label-lg": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 20,
      "fontWeight": "500",
      "lineHeight": 24,
      "letterSpacing": 0
    },
    "label-md": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 18,
      "fontWeight": "500",
      "lineHeight": 24,
      "letterSpacing": 0
    },
    "label-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 16,
      "fontWeight": "500",
      "lineHeight": 22,
      "letterSpacing": 0
    },
    "caption-sm": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 12,
      "fontWeight": "700",
      "lineHeight": 16,
      "letterSpacing": 0
    },
    "caption-xs": {
      "fontFamily": "Atkinson Hyperlegible Next",
      "fontSize": 9,
      "fontWeight": "700",
      "lineHeight": 16,
      "letterSpacing": 0
    }
  },
  "components": {
    "button-primary": {
      "backgroundColor": "#00857d",
      "textColor": "#ffffff",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "button-primary-hover": {
      "backgroundColor": "#006e68"
    },
    "button-primary-active": {
      "backgroundColor": "#005854"
    },
    "button-primary-disabled": {
      "backgroundColor": "#999999"
    },
    "button-secondary": {
      "backgroundColor": "#ffffff",
      "textColor": "#00857d",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "button-secondary-hover": {
      "backgroundColor": "#e6f3f2"
    },
    "button-tertiary": {
      "backgroundColor": "#ffffff",
      "textColor": "#00857d",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "button-tertiary-hover": {
      "backgroundColor": "#e6f3f2"
    },
    "button-onearly": {
      "backgroundColor": "#6356e5",
      "textColor": "#ffffff",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "button-social": {
      "backgroundColor": "#f2f2f2",
      "textColor": "#1a1a1a",
      "typography": "label-sm",
      "rounded": "8px",
      "padding": "12px",
      "height": "40px"
    },
    "chip-onearly-selected": {
      "backgroundColor": "#6356e5",
      "textColor": "#ffffff",
      "rounded": "9999px"
    },
    "button-secondary-tint": {
      "backgroundColor": "#e6f3f2",
      "textColor": "#006e68",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "button-ghost": {
      "backgroundColor": "transparent",
      "textColor": "#00857d",
      "typography": "label-md",
      "rounded": "8px",
      "padding": "12px"
    },
    "button-destructive": {
      "backgroundColor": "#b2282e",
      "textColor": "#ffffff",
      "typography": "label-md",
      "rounded": "8px"
    },
    "button-destructive-ghost": {
      "backgroundColor": "transparent",
      "textColor": "#b2282e",
      "typography": "label-md"
    },
    "chip": {
      "backgroundColor": "#ffffff",
      "textColor": "#00857d",
      "typography": "label-sm",
      "rounded": "9999px",
      "padding": "8px",
      "height": "36px"
    },
    "chip-selected": {
      "backgroundColor": "#cce7e5",
      "textColor": "#005854"
    },
    "assist-chip": {
      "backgroundColor": "#ffffff",
      "textColor": "#00857d",
      "borderColor": "#00857d",
      "typography": "label-sm",
      "rounded": "24px",
      "paddingHorizontal": "12px",
      "paddingVertical": "8px"
    },
    "answer-option": {
      "backgroundColor": "#ffffff",
      "textColor": "#00857d",
      "borderColor": "#00857d",
      "typography": "title-lg",
      "rounded": "8px",
      "padding": "12px",
      "height": "52px"
    },
    "answer-option-selected": {
      "backgroundColor": "#cce7e5",
      "textColor": "#005854"
    },
    "answer-option-muted": {
      "backgroundColor": "#eeeeea",
      "textColor": "#7f7f7f",
      "borderColor": "#7f7f7f"
    },
    "badge": {
      "backgroundColor": "#0f6764",
      "textColor": "#ffffff",
      "typography": "caption-sm",
      "rounded": "9999px",
      "padding": "4px"
    },
    "timer-chip": {
      "backgroundColor": "#ff7a3d",
      "textColor": "#ffffff",
      "typography": "headline-sm",
      "rounded": "9999px",
      "padding": "8px"
    },
    "timer-ring": {
      "backgroundColor": "transparent",
      "borderColor": "#ff7a3d",
      "borderWidth": "16px",
      "textColor": "#1a1a1a",
      "typography": "display-lg",
      "rounded": "9999px"
    },
    "card": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "rounded": "12px",
      "padding": "16px"
    },
    "task-row": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "typography": "title-md",
      "rounded": "16px",
      "padding": "12px",
      "height": "92px",
      "boxShadow": "0 0 6px 0 #0000001a"
    },
    "card-featured": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "rounded": "12px",
      "padding": "16px"
    },
    "card-featured-header": {
      "backgroundColor": "#cce7e5",
      "textColor": "#005854",
      "typography": "label-sm"
    },
    "stat-tile-header": {
      "backgroundColor": "#0071ce",
      "textColor": "#ffffff",
      "typography": "caption-sm",
      "padding": "12px"
    },
    "stat-tile": {
      "backgroundColor": "#e7f2fc",
      "textColor": "#1a1a1a",
      "typography": "title-lg",
      "rounded": "8px",
      "padding": "16px"
    },
    "input": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "typography": "body-md",
      "rounded": "8px",
      "padding": "12px",
      "height": "48px"
    },
    "input-focus": {
      "borderColor": "#00857d"
    },
    "alert-info": {
      "backgroundColor": "transparent",
      "textColor": "#4a4a4a",
      "typography": "body-sm",
      "padding": "12px"
    },
    "alert-error": {
      "backgroundColor": "#fbeaec",
      "textColor": "#4a4a4a",
      "typography": "body-md",
      "rounded": "12px",
      "padding": "12px"
    },
    "overview-card": {
      "backgroundColor": "#e3f7f5",
      "textColor": "#1a1a1a",
      "typography": "title-lg",
      "rounded": "20px",
      "padding": "16px"
    },
    "stat-card": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "borderColor": "#a8e4df",
      "typography": "stat-value",
      "rounded": "20px",
      "padding": "12px"
    },
    "list-row": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "borderColor": "#eeeeea",
      "typography": "label-md",
      "padding": "12px",
      "height": "48px"
    },
    "progress-bar": {
      "backgroundColor": "#eeeeea",
      "rounded": "9999px",
      "height": "16px"
    },
    "progress-card": {
      "backgroundColor": "#ffefe7",
      "borderColor": "#ffa77d",
      "textColor": "#1a1a1a",
      "typography": "label-md",
      "rounded": "24px",
      "padding": "16px"
    },
    "leader-card": {
      "backgroundColor": "#e3f7f5",
      "borderColor": "#6ed6d0",
      "textColor": "#1a1a1a",
      "typography": "title-sm",
      "rounded": "24px",
      "padding": "16px"
    },
    "tag": {
      "backgroundColor": "#00477f",
      "textColor": "#ffffff",
      "typography": "caption-sm",
      "rounded": "4px",
      "padding": "8px"
    },
    "tag-role": {
      "backgroundColor": "#cfe5f8",
      "textColor": "#0071ce",
      "typography": "body-xs",
      "lineHeight": "16px",
      "rounded": "4px",
      "padding": "4px"
    },
    "tag-info": {
      "backgroundColor": "#e7f2fc",
      "textColor": "#005faa",
      "typography": "caption-sm",
      "rounded": "9999px",
      "padding": "8px"
    },
    "segmented-control": {
      "backgroundColor": "#eeeeea",
      "textColor": "#00857d",
      "typography": "label-sm",
      "rounded": "9999px"
    },
    "segmented-control-selected": {
      "backgroundColor": "#005854",
      "textColor": "#ffffff"
    },
    "search-field": {
      "backgroundColor": "#ffffff",
      "textColor": "#1a1a1a",
      "typography": "body-md",
      "rounded": "9999px",
      "borderColor": "#7f7f7f",
      "height": "48px"
    },
    "welcome-card-group": {
      "backgroundColor": "#0071ce",
      "textColor": "#ffffff",
      "typography": "headline-lg",
      "rounded": "24px",
      "padding": "16px"
    },
    "group-card": {
      "backgroundColor": "#dfe5d5",
      "borderColor": "#a4b38e",
      "textColor": "#1a1a1a",
      "typography": "label-md",
      "rounded": "24px",
      "padding": "16px"
    },
    "workspace-pill": {
      "backgroundColor": "#ffffff",
      "borderColor": "#eeeeea",
      "textColor": "#1a1a1a",
      "typography": "label-lg",
      "rounded": "9999px",
      "padding": "8px",
      "height": "64px"
    },
    "progress-bar-fill": {
      "backgroundColor": "#ff7a3d",
      "rounded": "9999px"
    },
    "tab-bar": {
      "backgroundColor": "#cce7e5",
      "textColor": "#ffffff",
      "rounded": "9999px",
      "height": "64px",
      "padding": "4px"
    },
    "tab-bar-active": {
      "backgroundColor": "#00857d",
      "textColor": "#ffffff",
      "rounded": "9999px"
    },
    "streak-day-done": {
      "backgroundColor": "#ff7a3d",
      "textColor": "#ffffff",
      "typography": "title-md",
      "rounded": "9999px",
      "size": "32px"
    },
    "streak-day-today": {
      "backgroundColor": "#ffffff",
      "textColor": "#ff7a3d",
      "borderColor": "#ff7a3d",
      "typography": "title-md",
      "rounded": "9999px",
      "size": "32px"
    },
    "streak-day-upcoming": {
      "backgroundColor": "#ffffff",
      "textColor": "#4a4a4a",
      "borderColor": "#4a4a4a",
      "typography": "title-md",
      "rounded": "9999px",
      "size": "32px"
    }
  }
} as const;

export type ThemeColor = keyof typeof theme.colors;
export type ThemeSpacing = keyof typeof theme.spacing;
export type ThemeRadius = keyof typeof theme.radius;
export type ThemeTypography = keyof typeof theme.typography;
export type ThemeComponent = keyof typeof theme.components;

/** Font family names as loaded on native (must match the font file names, see uniwind docs). */
export const fontFamilies = {
  regular: 'AtkinsonHyperlegibleNext-Regular',
  medium: 'AtkinsonHyperlegibleNext-Medium',
  bold: 'AtkinsonHyperlegibleNext-Bold',
} as const;
